import { getDefaultExportFromCjs as r } from "./contact-channels155.js";
import { __require as e } from "./contact-channels156.js";
var t = e();
const i = /* @__PURE__ */ r(t);
export {
  i as default
};
//# sourceMappingURL=contact-channels108.js.map
